import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import './assets/base.scss'
import './assets/element-variables.scss'
import App from './App.vue'
import router from './router'
import { Container, Main, Footer, Row, Col } from "element-ui"

Vue.use(Container)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Row)
Vue.use(Col)
Vue.use(VueAxios, axios)


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
